/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Step_AddInputs */

const en_editor_step_add = /** @type {(inputs: Editor_Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

const de_editor_step_add = /** @type {(inputs: Editor_Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt`)
};

/**
* | output |
* | --- |
* | "Step" |
*
* @param {Editor_Step_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_add = /** @type {((inputs?: Editor_Step_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_add(inputs)
	return en_editor_step_add(inputs)
});